import Icon from "../Icon";
import PopOver from "../PopOver";
import Colors from "../../constants/Colors";

type Props = {
  title: string;
  children: React.ReactNode;
  interactive?: boolean;
};

export function ContextualNotification({
  children,
  title,
  interactive,
}: Props) {
  const content = (
    <div className="contextual-notification">
      <h2>{title}</h2>
      {children}
    </div>
  );
  return (
    // @ts-expect-error TS(2322) FIXME: Type '{ children: Element; content: Element; inter... Remove this comment to see the full error message
    <PopOver content={content} interactive={interactive}>
      <div
        className="contextual-notification-icon"
        data-testid="contextual-notification-icon"
      >
        <Icon
          name="icon2-eh-notification nav-icon"
          color={Colors.EH_RED_ORANGE_3}
        />
      </div>
    </PopOver>
  );
}

export default ContextualNotification;
